module.exports = __webpack_public_path__ + "img/no-game.f5e729b2.png";